import AUDITUDE_DEFAULTS from '../defaults/Auditude';
import queryString from 'query-string';
import { hasUserConsentLib, inUserConsentState, isCCPA } from '../../utils/UserConsent';

class Auditude {
    constructor(player = null, config = {}) {
        this.config = this.getConfig(config);
        this.ASPlayer = player;
    }


    getConfig(config) {
        return Object.assign({}, AUDITUDE_DEFAULTS, config.auditude);
    }


    buildURL(videoSource, cdnToken) {
        const base64ContentURL = btoa(`${videoSource.contentURL}?hdnts=${cdnToken}`);
        const contentID = `${videoSource.mediaId}`;
        const baseURL = `${this.config.basePath}/${contentID}/${base64ContentURL}.${this.config.manifestType}`;

        // if user in ccpa region and has ads cookies turned off, set privacy flag
        let privacyFlag = '';
        if (hasUserConsentLib() && isCCPA() && !inUserConsentState(['ads-general', 'behavior-general', 'perf-general'])) {
            privacyFlag = '1NYN';
        }

        const queryParams = {
            g: this.config.clientType,
            z: this.config.zoneID,
            u: this.config.assetTag,
            pttrackingversion: this.config.ptTrackingVersion,
            pttoken: this.config.ptToken,
            ptcueformat: this.config.ptCueFormat,
            ptassetid: contentID,
            // pttrackingmode: this.config.ptTrackingMode,
            ptdebug: this.config.ptDebug,
            live: (videoSource.type === 'stream') ? true : false,
            // pttimeline: this.config.ptLiveTimeline, // only works for live streams (vod needs a constructed timeline - change this is ever doing VOD SSAI)
            __sid__: `${contentID}:${Date.now()}`,
            k: `_fw_ae=725bd42fc9c9394e790b9a73610da431;stream=${this.config.adobeStreamID};caid=${contentID};vdur=0;_fw_ar=0;idfa=${this.config.advertisingID};_fw_us_privacy=${privacyFlag}`,
        }

        return `${baseURL}?${queryString.stringify(queryParams, { encode: false })}`;
    }


    buildTrackingURL(levelURL, programDateTime) {
        let parsedURL = queryString.parseUrl(levelURL);

        parsedURL.url = parsedURL.url.replace('.m3u8', '.json');
        parsedURL.query = Object.assign({}, parsedURL.query, { pttrackingposition: programDateTime })

        return `${parsedURL.url}?${queryString.stringify(parsedURL.query, { encode: false })}`;
    }

    onAdClick(clickThroughURL, player) {
        player.pause();

        const adPage = window.open(clickThroughURL, '_blank');
        adPage.focus();
    }
}


export default Auditude;



// WEBPACK FOOTER //
// ./src/ads/auditude/index.js